import { RouterProvider } from 'react-router-dom';
import { AppProvider } from './contexts';
import { router } from './router/routes';

const App = () => {
  return (
    <AppProvider>
      <RouterProvider router={router} />
    </AppProvider>
  );
};

export default App;